<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.push('/os_tablets')" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <h2>{{ modoCriacao ? 'OS Configuração e montagem de Tablets' : `${OS.codigo ?? ''} - ${OS.descricao ??
                ''}` }}</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="loading" v-if="loading">
            <div></div>
        </div>
        <form v-else @submit.prevent="criarOS" class="bloco margem grid-1">
            <fieldset class="grid-3">
                <div><label>Cliente</label>
                    <select v-model="OS.id_cliente" :required="isRequired('id_cliente')"
                        @change="atualizarPayload('id_cliente', OS.id_cliente)">
                        <option hidden></option>
                        <option v-for="cli in clientes" :key="cli.id" :value="cli.id">{{ cli.nome }}</option>
                    </select>
                </div>
                <div>
                    <label>Descrição</label>
                    <input type="text" v-model="OS.descricao" :required="isRequired('descricao')"
                        @change="atualizarPayload('descricao', OS.descricao)">
                </div> 
                <div><label>Data Prevista de Conclusão</label>
                    <input type="date" v-model="OS.fim_previsto" :required="isRequired('fim_previsto')"
                        @change="atualizarPayload('fim_previsto', OS.fim_previsto)">
                </div>
                <div><label>Data da Criação</label>
                    <input type="date" :value="dataParaInput(OS.created_at)" readonly>
                </div>
                <div><label>Quantidade</label>
                    <input type="number" v-model="OS.qtd" :required="isRequired('qtd')"
                        @change="atualizarPayload('qtd', OS.qtd)">
                </div>
                <div><label>Marca <i class="bi bi-gear-fill" title="Cadastrar Marca"
                            @click="tipoModal = 'Marca', showModal = true"></i></label>
                    <select v-model="OS.id_marca" :required="isRequired('id_marca')"
                        @change="atualizarPayload('id_marca', OS.id_marca)">
                        <option v-for="mar in marcas" :key="mar.id" :value="mar.id">{{ mar.nome }}</option>
                    </select>
                </div>
                <div><label>Modelo <i class="bi bi-gear-fill" title="Cadastrar Modelo"
                            @click="tipoModal = 'Modelo', showModal = true"></i></label>
                    <select v-model="OS.id_modelo" :required="isRequired('id_modelo')"
                        @change="atualizarPayload('id_modelo', OS.id_modelo)">
                        <option v-for="mod in modelos" :key="mod.id" :value="mod.id">{{ mod.nome }}</option>
                    </select>
                </div>
                <div><label>Operadora <i class="bi bi-gear-fill" title="Cadastrar Operadora"
                            @click="tipoModal = 'Operadora', showModal = true"></i></label>
                    <select v-model="OS.id_operadora" :required="isRequired('id_operadora')"
                        @change="atualizarPayload('id_operadora', OS.id_operadora)">
                        <option v-for="ope in operadoras" :key="ope.id" :value="ope.id">{{ ope.nome }}</option>
                    </select>
                </div>
                <div><label>Nota fiscal</label>
                    <input type="text" v-model="OS.nota_fiscal" :required="isRequired('nota_fiscal')"
                        @change="atualizarPayload('nota_fiscal', OS.nota_fiscal)">
                </div>
                <div class="col-3">
                    <label>Observações/Escopo</label>
                    <textarea v-model="OS.obs" :required="isRequired('obs')"
                        @change="atualizarPayload('obs', OS.obs)"></textarea>
                </div>
            </fieldset>
            <div class="submit" style="justify-content: right;" v-if="modoCriacao && !criando">
                <button type="button" class="acao-secundaria"
                    @click="this.$router.push('/os_tablets')">Cancelar</button>
                <button type="submit" :disabled="camposVazios">Criar</button>
            </div>
            <div v-else-if="criando" class="loading">
                <div></div>
            </div>
            <div v-else class="submit" style="justify-content: right;">
                <button type="button" @click="salvarAlteracoes"
                    :disabled="semAlteracoes || camposVazios">Salvar</button>
            </div>
        </form>
    </div>

    <ModalCadastrarItemOsTablets :mostrar="showModal" :tipo="tipoModal" :lista="listaModal"
        @fechar="showModal = false" @cadastrar="cadastrarItem" @excluir="excluirItemSelect" />
</template>

<script>
import { dataParaInput } from "@/utils/date";
import serviceOsTablets from '@/services/serviceOsTablets';
import { createToaster } from "@meforma/vue-toaster";
import ModalCadastrarItemOsTablets from '@/components/Modais/protocolos/ModalCadastrarItemOsTablets.vue';

const toaster = createToaster({
    position: "top-right",
    duration: 2000,
});

export default {
    components: { ModalCadastrarItemOsTablets },
    data() {
        return {
            tipoModal: null,
            showModal: false,
            OS: {
                created_at: new Date().toISOString()
            },
            payloadAlteracoes: {},
            clientes: [],
            marcas: [],
            modelos: [],
            operadoras: [],
            loading: true,
            criando: false,
            camposObrigatorios: [
                'fim_previsto',
                'qtd',
                'nota_fiscal',
                'descricao',
                // 'obs',
                'id_cliente',
                'id_marca',
                'id_modelo',
                'id_operadora'
            ]
        }
    },
    props: {
        id: {
            required: true
        },
    },
    beforeRouteLeave(to, from, next) {
        if (!this.semAlteracoes) {
            const sair = confirm('Você tem alterações não salvas. Deseja sair mesmo assim?');
            if (!sair) return next(false);
        }
        next();
    },

    computed: {
        modoCriacao() {
            return this.id === 'criar'
        },
        camposVazios() {
            return this.camposObrigatorios.some(c => !this.OS[c]);
        },
        semAlteracoes() {
            return Object.keys(this.payloadAlteracoes).length === 0 && this.payloadAlteracoes.constructor === Object;
        },
        listaModal() {
            const t = (this.tipoModal || '').toLowerCase();
            if (t === 'marca') return this.marcas;
            if (t === 'modelo') return this.modelos;
            if (t === 'operadora') return this.operadoras;
            return [];
        }
    },
    async mounted() {
        window.addEventListener('beforeunload', this.onBeforeUnload);
        const [cli, mar, mod, ope] = await Promise.all([
            serviceOsTablets.getClientes(),
            serviceOsTablets.crudMarcas('get'),
            serviceOsTablets.crudModelos('get'),
            serviceOsTablets.crudOperadoras('get'),
        ]);
        this.clientes = cli;
        this.marcas = mar;
        this.modelos = mod;
        this.operadoras = ope;

        if (!this.modoCriacao) {
            this.OS = await this.getOs();
        }
        this.loading = false
    },
    unmounted() {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
    },
    methods: {
        dataParaInput,
        async excluirItemSelect(id) {
            const tipo = (this.tipoModal || '').toLowerCase();

            if (tipo === 'marca') {
                await serviceOsTablets.crudMarcas('delete', null, id);
                this.marcas = this.marcas.filter(i => i.id !== id);
            }

            else if (tipo === 'modelo') {
                await serviceOsTablets.crudModelos('delete', null, id);
                this.modelos = this.modelos.filter(i => i.id !== id);
            }

            else if (tipo === 'operadora') {
                serviceOsTablets.crudOperadoras('delete', null, id);
                this.operadoras = this.operadoras.filter(i => i.id !== id);
            }
        },
        async cadastrarItem(valor) {
            const v = (valor || '').trim();
            if (!v) return;
            const tipo = (this.tipoModal || '').toLowerCase();
            const normaliza = s => s.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
            const jaExiste = (lista) => lista.some(x => normaliza(x.nome) === normaliza(v));
            if (tipo === 'marca') {
                if (jaExiste(this.marcas)) return;
                const criado = await serviceOsTablets.crudMarcas('post', { nome: v });
                this.marcas.push(criado.data);
            } else if (tipo === 'modelo') {
                if (jaExiste(this.modelos)) return;
                const criado = await serviceOsTablets.crudModelos('post', { nome: v, descricao: '' });
                this.modelos.push(criado.data);
            } else if (tipo === 'operadora') {
                if (jaExiste(this.operadoras)) return;
                const criado = await serviceOsTablets.crudOperadoras('post', { nome: v, descricao: '' });
                this.operadoras.push(criado.data);
            }
        },
        async cadastrarItemSelect(event) {
            const valor = event?.target?.value?.trim();
            if (valor) await this.cadastrarItem(valor);
            if (event?.target) event.target.value = '';
        },
        async salvarAlteracoes() {
            await serviceOsTablets.crudOS('put', this.payloadAlteracoes, this.OS.id);
            this.payloadAlteracoes = {}
            toaster.success('Alterações salvas!')
        },
        atualizarPayload(campo, valor) {
            if (!this.modoCriacao) {
                this.payloadAlteracoes[campo] = valor
            }
        },
        async criarOS() {
            this.criando = true
            await serviceOsTablets.crudOS('post', this.OS);
            toaster.success('OS Criada com Sucesso!');
            this.criando = false
            this.$router.push({ name: 'listagemOsTablets' })
        },
        isRequired(campo) {
            return this.camposObrigatorios.includes(campo) && !this.OS[campo]
        },
        async getOs() {
            if (!this.modoCriacao) {
                return await serviceOsTablets.crudOS('get', null, this.id)
            }
            return null
        },
        onBeforeUnload(e) {
            if (!this.semAlteracoes) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

    },
}
</script>

<style scoped>
.bi.bi-gear-fill {
    display: inline-block;
    transition: transform .3s ease;
    color: var(--cor-fonte-fraca);
}

.bi.bi-gear-fill:hover {
    transform: rotate(20deg);
    font-size: 16px;
    cursor: pointer;
}

.bi-trash-fill {
    color: var(--cor-erro);
    cursor: pointer;
    transition: all 100ms linear;
}

.bi-trash-fill:hover {
    font-size: 16px
}
</style>